import NestedAccordion from "../../../components/NestedAccordion";

import FileUploadField from "@/components/ui/FileUploadField";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import DescBox from "@/components/ui/DescBox";

import { getTimeDifference } from "@/utils/getTimeDifference";
import Modal from "@/components/ui/Modal";
import {
  EditingStageAdminRequiredActions,
  TVideoEditing,
} from "@/types/projectType";
import {
  useRequestVideoEditingTimeLineExtensionMutation,
  useUploadRevisedVideoEditingFileMutation,
  useUploadVideoEditingFileMutation,
} from "@/redux/feature/orderManagement/videoEditing/videoEditingApi";
import { FileDetails } from "@/types/types";
import { FileCard } from "@/pages/orderMananagement/components/FileCard";
import { RevisionFileCard } from "@/pages/orderMananagement/components/RevisionFileCard";
import { handleApiRequest } from "@/utils/handleApiRequest";

const timeLineOptions = [
  { id: "3", value: 3, title: "3 Hours" },
  { id: "12", value: 6, title: "6 Hours" },
  { id: "24", value: 9, title: "9 Hours" },
];

const VideoEditing = ({
  videoEditingData,
  ActionsRequired,
}: {
  ActionsRequired?: EditingStageAdminRequiredActions[];
  videoEditingData: TVideoEditing;
}) => {
  const isActionRequired = ActionsRequired?.find(
    (item) =>
      item?.isVideoEditingUploaded === false ||
      item?.isRevisedVideoEditingUploaded === false
  );
  // Grabbing Important params
  const [searchParams] = useSearchParams();
  const { id: orderId } = useParams();
  const videoId = searchParams.get("videoId");

  const timeLine = getTimeDifference(videoEditingData?.adminTimeLine);

  const [clearFiles, setClearFiles] = useState(false);
  const [file, setfile] = useState<FileDetails[]>([]);
  const [showReqAnExtensionModal, setShowReqAnExtensionModal] = useState(false);

  //Api hooks
  const [uploadVideoEditingFile, { isLoading: uploadingFile }] =
    useUploadVideoEditingFileMutation();
  const [uploadRevisedVideoEditingFile, { isLoading: uploadingRevisedFile }] =
    useUploadRevisedVideoEditingFileMutation();
  const [requestVideoEditingTimeLineExtension] =
    useRequestVideoEditingTimeLineExtensionMutation();

  const handleUploadRawFootage = async () => {
    if (file.length === 0) {
      return;
    }
    if (videoEditingData?.requiredActions?.requiresRevision) {
      const payload = {
        orderId,
        videoId,
        data: {
          description: "Video Editing file From Admin",
          newVideoFile: file[0],
        },
      };
      await handleApiRequest({
        payload: payload,
        requestFunction: uploadRevisedVideoEditingFile,
        onSuccess: (res) => {
          toast.success("Edited Video successfully!");
          // setOpen(sfalse);
          setfile([]);
          setClearFiles(true);
          console.log(res);
        },
        onError: (err) => {
          console.log(err);
          toast.error(err.message || "Failed to Upload  Edited Video ");
        },
      });
    } else {
      const payload = {
        order_id: orderId,
        video_id: videoId,
        videoEditingVersions: [
          {
            versionNumber: 1,
            uploadedBy: "admin",
            description: "First version of Edited Video",
            file: file,
            uploadedAt: new Date(),
          },
        ],
      };

      await handleApiRequest({
        payload: payload,
        requestFunction: uploadVideoEditingFile,
        onSuccess: (res) => {
          toast.success("Edited Video Uploaded successfully!");
          // setOpen(sfalse);
          setfile([]);
          setClearFiles(true);
          console.log(res);
        },
        onError: (err) => {
          console.log(err);
          toast.error(err.message || "Failed to Upload  Edited Video ");
        },
      });
      // try {
      //   console.log(payload);
      //   const res = await uploadVideoEditingFile(payload).unwrap();
      //   if (res.success) {
      //     toast.success("Edited Video Uploaded successfully!");
      //     // setOpen(sfalse);
      //     setfile([]);
      //     setClearFiles(true);
      //   } else {
      //     toast.error(res.message || "Failed to Upload  Edited Video ");
      //   }
      // } catch (err) {
      //   console.log(err);
      // }
    }
  };
  // Toggle Extension Modal
  const toggleExtensionModal = (value: boolean) => {
    setShowReqAnExtensionModal(value);
  };

  const currentEditedVideoVersion =
    videoEditingData?.videoEditingVersions?.slice(-1)[0];
  const { inProgress = false, isApproved = false } =
    videoEditingData?.status || {};
  const { requiresRevision = false, requiresApproval = false } =
    videoEditingData?.requiredActions || {};

  const Status =
    requiresRevision === true
      ? "Needs Revision"
      : requiresApproval === true
      ? "Not Approved Yet"
      : inProgress === true
      ? " In Progress"
      : isApproved === true
      ? "Approved"
      : "";
  const [isOpen, setIsOpen] = useState(false);
  const showAllVersion = !isApproved && !requiresRevision;
  useEffect(() => {
    if (
      !isActionRequired?.isRevisedVideoEditingUploaded === false ||
      !isActionRequired?.isVideoEditingUploaded === false
    ) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [
    isActionRequired?.isRevisedVideoEditingUploaded,
    isActionRequired?.isVideoEditingUploaded,
  ]);
  return (
    <NestedAccordion
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      actionRequired={
        isActionRequired?.isRevisedVideoEditingUploaded === false ||
        isActionRequired?.isVideoEditingUploaded === false
      }
      title="Video Editing"
      initiallyOpen={!isApproved || requiresRevision}
      status={Status}
      isApproved={isApproved}
      timeLine={timeLine}
      initiated={videoEditingData ? true : false}
    >
      <div className="p-3">
        {/* Showing main file or file upload field based on logic */}
        {!isApproved && !requiresApproval && (
          <div className="rounded-[10px]">
            <FileUploadField
              clearFiles={clearFiles}
              onFilesUploaded={(file) => setfile(file)}
              maxFiles={1}
            />
          </div>
        )}

        {isApproved && (
          <>
            <p className="text-[13px] font-medium mt-4">Final Version</p>
            <FileCard
              active={true}
              file={currentEditedVideoVersion?.file[0]}
              isApproved={isApproved}
            />
          </>
        )}

        {/* Show that file that needs revision*/}
        {requiresRevision && (
          <>
            <p className="text-[13px] font-medium mt-4">
              Request Revisions (
              {videoEditingData?.videoEditingVersions?.length})
            </p>
            <RevisionFileCard
              active={true}
              file={currentEditedVideoVersion?.file[0]}
              comment={currentEditedVideoVersion?.revisionComment as string}
            />
          </>
        )}

        {/* Showing all versions */}
        <div>
          {videoEditingData?.videoEditingVersions
            ?.slice(0, showAllVersion ? undefined : -1)
            ?.reverse().length > 0 && (
            <div>
              <p className="text-[13px] font-medium mt-4">Previous Version</p>
              {videoEditingData?.videoEditingVersions
                ?.slice(0, showAllVersion ? undefined : -1)
                ?.reverse()
                .map((item, i) => (
                  <FileCard
                    requiresRevision={false}
                    key={i}
                    active={false}
                    file={item?.file[0]}
                  />
                ))}
            </div>
          )}
        </div>
      </div>
      <div className="bg-[#F5F9FF] p-3 rounded-bl-xl rounded-br-xl flex justify-between items-center">
        <p className="text-sm text-[#344054] font-medium">Cancel</p>
        <button
          onClick={handleUploadRawFootage}
          disabled={file.length === 0 || uploadingRevisedFile || uploadingFile}
          className="text-white disabled:opacity-50 text-sm px-3 py-2 font-semibold rounded-lg bg-[#17457D]"
        >
          {uploadingFile || uploadingRevisedFile
            ? "Submitting..."
            : "Submit upload"}
        </button>
      </div>
    </NestedAccordion>
  );
};

export default VideoEditing;
